import { useOnboardingStore } from '@/store/onboardingStore';
import { ChipGroup } from '../components/ChipGroup';
import type { Attack } from '@/types/onboarding';

const ATTACK_OPTIONS: { value: Attack; label: string; icon: string }[] = [
    { value: 'single_leg', label: 'Single Leg', icon: '🦵' },
    { value: 'double_leg', label: 'Double Leg', icon: '🚀' },
    { value: 'high_crotch', label: 'High Crotch', icon: '🎯' },
    { value: 'snap_down', label: 'Snap Down', icon: '👇' },
    { value: 'firemans_carry', label: 'Firemans', icon: '🔥' },
    { value: 'ankle_pick', label: 'Ankle Pick', icon: '🦴' },
    { value: 'blast_double', label: 'Blast Double', icon: '💥' },
    { value: 'duck_under', label: 'Duck Under', icon: '🦆' },
];

export function AttackScreen() {
    const { profile, setTopAttack, nextStep } = useOnboardingStore();

    const handleSelect = (val: string | string[]) => {
        const selected = Array.isArray(val) ? val[0] : val;
        setTopAttack(selected as Attack);
        setTimeout(nextStep, 300);
    };

    return (
        <div className="px-2 animate-fade-in-right">
            <h2 className="text-xl font-bold text-text-primary mb-2">
                Top Attack
            </h2>
            <p className="text-text-secondary text-sm mb-6">
                What is your go-to takedown?
            </p>

            <ChipGroup
                options={ATTACK_OPTIONS}
                selected={profile.topAttack || ''}
                onChange={handleSelect}
                columns={2}
            />
        </div>
    );
}
